import { render, staticRenderFns } from "./BricmateProduct.vue?vue&type=template&id=8e11aa24&"
import script from "./BricmateProduct.ts?vue&type=script&lang=ts&"
export * from "./BricmateProduct.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports